import styles from '@/styles/addressForm.module.scss'
import { Button, Form, Input, Space, Select, message } from 'antd';
import { useState, useEffect } from 'react';
import CloseIcon from '@/svgs/close-hover.svg'
import myAccountApi from '@/service/modules/myAccountApi'

interface Address {
  address: string,
  address1: string,
  addressID: number,
  firstName: string,
  lastName: string,
  phone: string,
  postCode: string,
  suburb: string,
  state: number
}

interface AddressFormProps {
  address: Address | null
  success: any
  cancel: any
}

export default function AddressForm({ address, success, cancel }: AddressFormProps) {
  const [form] = Form.useForm();
  const { Option } = Select

  interface suburbOptionsItem {
    subID: number,
    subName: string,
    zoneID: string,
    zoneCode: string,
    zoneName: string,
    countryID: number
  }
  const [suburbOptions, setSuburbOptions] = useState<suburbOptionsItem[]>([]);
  const [isEdit, setIsEdit] = useState(false);

  // postCode数值变化
  const changePostCode = () => {
    const postCode = form.getFieldsValue().postCode

    // 判断合规
    if (postCode.length != 4) return
    if (!postCode.match(/^\d{4}$/)) return

    // 请求suburb数据
    getSuburbOptions(postCode, true)
    console.log(true)
  }

  // Suburb数值变化
  const handleSuburbChange = () => {
    const suburb = form.getFieldsValue().suburb
    const target = suburbOptions.filter(item => item.subName === suburb)

    // 给state赋值
    if (target.length) {
      form.setFieldsValue({
        state: target[0].zoneCode
      })
    }
  }

  // 获取suburb state
  const getSuburbOptions = async (postCode: string, defaultAssign?: boolean) => {
    try {
      let res = await myAccountApi.getSubAndStatByPostcode({ postCode: postCode })
      if (res.data && res.data.length) {
        setSuburbOptions(res.data)

        // postCode更改的触发，Suburb取第一条为默认值
        if (defaultAssign) {
          form.setFieldsValue({
            suburb: res.data[0].subName,
            state: res.data[0].zoneCode
          })
        }
      } else {
        setSuburbOptions([])
        form.setFieldsValue({
          suburb: '',
          state: ''
        })
      }
    } catch (error) {
      setSuburbOptions([]) // 请求失败时可以设置为空数组或处理其他错误逻辑
      console.error(error)
    }
  }

  useEffect(() => {
    setIsEdit(!!(address?.addressID))

    if (address?.addressID) {
      form.setFieldsValue(address)
      getSuburbOptions(address.postCode)
    } else {
      form.resetFields()
    }
  }, [address, form]);

  // 校验成功，发起提交请求
  const onFinish = (values: any) => {
    console.log('Success:', values)

    saveAddress(values)
  }

  // 提交新增/编辑地址
  const saveAddress = async (values: any) => {
    try {
      const dataObj: any = {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        zoneID: '',
        address: values.address,
        address1: values.address1,
        suburb: values.suburb,
        state: values.state,
        postCode: values.postCode
      }

      // 通过suburb反查zoneID
      if (values.suburb) {
        const target = suburbOptions.filter(item => item.subName === values.suburb)

        // 给zoneID赋值
        if (target.length) {
          dataObj.zoneID = target[0].zoneID
        }
      }

      // 判断新增还是编辑地址
      if (isEdit) dataObj.addressID = address?.addressID
      const params = isEdit ? myAccountApi.editAddresses : myAccountApi.addAddresses

      let res = await params(dataObj)
      if (res.data) {
        message.success('Success')
        success()
      }
    } catch (error: any) {
      message.error(error.message)
    }
  }

  return (
    <div className={styles['address-form']}>
      <div className={styles['close-box']}>
        <CloseIcon className={styles['close-icon']} onClick={cancel} />
      </div>

      <Form
        name="basic"
        layout="vertical"
        size={'large'}
        style={{ width: '100%' }}
        form={form}
        initialValues={{}}
        onFinish={onFinish}
        autoComplete="off"
        scrollToFirstError
      >

        <div className={styles['form-box']}>
          <div className={styles['box-item']}>
            <Form.Item
              label="Recipient Name"
              rules={[{ required: true }]}
              style={{ marginBottom: 0 }}
              required
            >
              <Space size={16}>
                <Form.Item
                  label=""
                  name="firstName"
                  rules={[
                    {
                      validator(_, value) {
                        const myLastname = form.getFieldValue('lastName')
                        console.log(value);
                        console.log(myLastname);

                        if (!value || !myLastname) {
                          return Promise.reject(new Error(`Please enter a value between 2 and 100 characters long.`));
                        } else if (value.length < 2 || myLastname.length < 2) {
                          return Promise.reject(new Error(`Please enter a value between 2 and 100 characters long.`));
                        } else if (value.length > 100) {
                          return Promise.reject(new Error(`The First Name length is no more than 100 characters.`));
                        } else if (myLastname.length > 100) {
                          return Promise.reject(new Error(`The Last Name length is no more than 100 characters.`));
                        }
                        return Promise.resolve()
                      },
                    },
                  ]}
                  style={{ display: 'block' }}
                >
                  <Input maxLength={60} placeholder="First Name" />
                </Form.Item>
                <Form.Item
                  label=""
                  name="lastName"
                  style={{ display: 'block' }}
                // rules={[
                //   { required: true, message: `'Last Name' is required` },
                //   {
                //     validator(_, value) {
                //       if (value && value.length < 2) {
                //         return Promise.reject(new Error(`'Last Name' is required`));
                //       }
                //       return Promise.resolve()
                //     },
                //   },
                // ]}
                >
                  <Input maxLength={60} placeholder="Last Name" onChange={() => { form.validateFields(['firstName']); }} />
                </Form.Item>
              </Space>
            </Form.Item>

            <div className={styles['post-code']}>
              <div className={styles['post-code-item']}>
                <Form.Item
                  label="PostCode"
                  name="postCode"
                  rules={[
                    { required: true, message: `Postcode is required.` },
                    {
                      validator: async (_, value) => {
                        const regex = /^[0-9]+$/;
                        if (value && !regex.test(value)) {
                          return Promise.reject('Numbers only.');
                        }
                        if (value && value.length === 4) {
                          try {
                            let res = await myAccountApi.getSubAndStatByPostcode({ postCode: value })
                            if (res.data && res.data.length) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(new Error('Not Available'));
                            }
                          } catch (error) {
                            return Promise.reject(new Error('Not Available'));
                          }
                        } else if (value && value.length > 4) {
                          return Promise.reject(new Error('Please enter a value between 0 and 4 characters long'));
                        }
                      }
                    }
                  ]}
                >
                  <Input type={'tel'} maxLength={4} placeholder="PostCode" onChange={changePostCode} />
                </Form.Item>
              </div>
              <div className={styles['post-code-item']}>
                <Form.Item
                  label="Suburb"
                  name="suburb"
                  rules={[{ required: true, message: `Surburb is required.` }]}
                >
                  <Select onChange={handleSuburbChange}>
                    {
                      !!(suburbOptions && suburbOptions.length) &&

                      suburbOptions.map((item: suburbOptionsItem) => (
                        <Option value={item.subName} key={item.subID}>{item.subName}</Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </div>
            </div>

            <Form.Item
              label="Street Address"
              name="address"
              rules={[{ required: true, message: `Address Line is required.` },]}
            >
              <Input maxLength={200} style={{ width: '100%' }} />
            </Form.Item>
          </div>

          <div className={styles['box-item']}>
            <Form.Item
              label="Phone Number (Example (04xxxxxxxx/03xxxxxxxx)"
              name="phone"
              rules={[
                { required: true, message: `Phone/Mobile is required.` },
                {
                  validator(_, value) {
                    if (value && !value.match(/^[0-9]+$/)) {
                      return Promise.reject(new Error('Numbers only'));
                    } else if (value && value.length != 10) {
                      return Promise.reject(new Error('Your phone number should be 10 characters long.'));
                    } else if (value && !value.match(/^[0][234578][0-9]{8}$/)) {
                      return Promise.reject(new Error('Invalid phone number.'));
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input type="tel" maxLength={10} placeholder="For delivery use only" />
            </Form.Item>

            <div className={styles['post-code']}>
              <div className={styles['post-code-item']}>
                <Form.Item
                  label="State"
                  name="state"
                  rules={[{ required: true, message: `State is required.` },]}
                >
                  <Input disabled />
                </Form.Item>
              </div>
              <div className={styles['post-code-item']}>
                <Form.Item label="Country" name="country">
                  <Input placeholder="Australia" disabled />
                </Form.Item>
              </div>
            </div>

            <Form.Item
              label="Address line 2 (optional)"
              name="address1"
            >
              <Input maxLength={200} />
            </Form.Item>
          </div>
        </div>


        {/* 提交按钮 */}
        <Form.Item>
          <div className={styles['btn-box']}>
            <Button className={styles['cancel-btn']} onClick={cancel}>
              Cancel
            </Button>
            <Button className={styles['save-btn']} htmlType="submit">
              Save to Address Book
            </Button>
          </div>
        </Form.Item>
      </Form>

    </div>
  )
}
